import BaseService from "./BaseService";

export default class FormsService extends BaseService {

  constructor() {
    super('newsletter')
  }

  retrieveSubscriber(data: any) {
    return new Promise((resolve, reject) => {
      this.api.post(`${this.API_PATH}retrieve-subscriber`, data)
        .then(res => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }

}